module.exports = __webpack_public_path__ + "img/Angiogenesis-MELA_SpatialResearch.2c56b854.png";